import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { lifecycle, compose, withHandlers } from 'recompose'
import { push } from 'connected-react-router'

import * as OrgActions from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'
import * as RoutingSelectors from 'modules/routing/selectors'
import { page, track } from 'utils/trackingUtils'

import CustomizeDrift from './component'

const mapStateToProps = state => ({
  iconStyle: OrgSelectors.getIcon(state),
  color: OrgSelectors.getColor(state),
  locale: OrgSelectors.getLocale(state),
  pathname: RoutingSelectors.getPathname(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setIcon: OrgActions.setIcon,
    updateEmbed: OrgActions.updateEmbed,
    setWelcomeMessage: OrgActions.setWelcomeMessage,
    setColor: OrgActions.setColor,
    updateOrgProperties: OrgActions.updateOrgProperties,
    push,
  }, dispatch)
})


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.updateOrgProperties({ properties: { lastStep: this.props.pathname } })
      page('Onboarding Widget Setup', {
        context: 'widget-onboarding',
      })
    }
  }),
  withHandlers({
    onIconChange: props => icon => {
      props.actions.setIcon(icon)
    },
    onSkipClick: props => () => {
      track('Onboarding Widget Setup Completed', {
        context: 'widget-onboarding',
        clearbitPrefillSelected: false,
        skipped: true
      })
    },
    onContinueClick: props => () => {
      track('Onboarding Widget Setup Completed', {
        context: 'widget-onboarding',
        clearbitPrefillSelected: false,
      })
      props.actions.updateEmbed([{
        operation: 'set',
        value: props.iconStyle,
        property: 'theme.iconStyle',
      }, {
        operation: 'set',
        value: props.color,
        property: 'theme.activeColor',
      }, {
        operation: 'set',
        value: props.color,
        property: 'theme.backgroundColor',
      }])
      props.actions.push('/setup/touchless/install')
    },
  })
)(CustomizeDrift)
